/** Tokens visuais — tipos de pagamento do evento (mesmo padrão dos recebimentos) */
export const TIPO_PAY_ACCENT = "#F96030";
export const TIPO_PAY_INK = "#1a2035";
export const TIPO_PAY_ACCENT_SOFT = "rgba(249, 96, 48, 0.08)";

export const tipoPayToolbarSx = {
  mb: 2,
  p: 2,
  borderRadius: 2,
  bgcolor: "grey.50",
  border: "1px solid",
  borderColor: "grey.200",
  borderLeft: `4px solid ${TIPO_PAY_ACCENT}`,
};

export const tipoPayModalPaperSx = {
  borderRadius: 3,
  overflow: "hidden",
  maxHeight: "92vh",
  display: "flex",
  flexDirection: "column" as const,
  width: { xs: "100%", sm: "96vw" },
  maxWidth: 560,
};

export const tipoPayModalHeaderSx = {
  px: 2.5,
  py: 2,
  background: `linear-gradient(135deg, ${TIPO_PAY_INK} 0%, #2d3561 100%)`,
  color: "#fff",
  borderBottom: `3px solid ${TIPO_PAY_ACCENT}`,
};
